var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVercelAnalytics = function SvgVercelAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#vercel-analytics_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vercel-analytics_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 2,
    fill: "#fff",
    rx: 16
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 2,
    fill: "#fff",
    fillOpacity: 0.2,
    rx: 16
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 2,
    fill: "#DEF1FF",
    fillOpacity: 0.31,
    rx: 16
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.5,
    height: 31.5,
    x: 2.25,
    y: 0.25,
    stroke: "#3291FF",
    strokeOpacity: 0.15,
    strokeWidth: 0.5,
    rx: 15.75
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0096FF",
    strokeOpacity: 0.44,
    d: "M0 7.5h39",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0096FF",
    strokeOpacity: 0.44,
    d: "M0 16.5h39",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0096FF",
    strokeOpacity: 0.44,
    d: "M0 25.5h39",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0070F3",
    fillOpacity: 0.26,
    stroke: "#0070F3",
    strokeWidth: 2,
    d: "M9 15.5-2 29l2 5 46-1L33.5 3.5 18 22.5z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "vercel-analytics_svg__b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 2,
    fill: "#fff",
    rx: 16
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vercel-analytics_svg__a",
    width: 36,
    height: 36,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2508_7604"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2508_7604",
    result: "shape"
  })))));
};
export default SvgVercelAnalytics;